export default "__VITE_ASSET__CuH7lrXn__"